var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.items),function(item){return [_c('kst-check',{key:item.ID,attrs:{"label":item.Name},model:{value:(item.IsSelected),callback:function ($$v) {_vm.$set(item, "IsSelected", $$v)},expression:"item.IsSelected"}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }